import { Atom } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.div`
  ${({ displayState, theme }) => css`
    width: 32px;
    height: 32px;
    margin: 2px;
    border-radius: 50%;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${displayState?.selected ? 'white' : '#666666'};
    cursor: pointer;
    &:hover {
      font-weight: 600;
    }
    background: ${displayState?.selected ? theme?.colour?.primary : ''};
  `}
`;

export default Atom({ type: 'button', dataType: 'string', template });